import axios from './getAxios';
import { PublicationsPayloadProps } from './types';

export default async (payload: PublicationsPayloadProps) => {

  const { data } = await axios({
    method: 'GET',
    url: '/api/publications/get',
    data: payload,
  });
  return data;
};